import List from "components/list";
import { useParams } from "react-router-dom";
import { RenderProfile } from "components/render-profile";
import { DateTimeCell } from "components/cell/date/cell";
import { getUserFields } from "components/user/config";
import { StatusCell } from "@/components/status/cell";
import { PermissionGate } from "permissions";
import HeaderPortal from "components/portal/header-portal";
import CreateItemButton from "components/buttons/create";
import OpeningInterviewsFilters from "./filters";

export default function OpeningsInterviews() {

    const { openingId } = useParams();

    const fields = [
        "id",
        getUserFields("applicant.employee"),
        "title",
        "status",
        "date_scheduled",
        "is_cleared"
    ];

    const columns = [
        {
            id: "applicant.employee",
            header: "Applicant",
            accessorKey: "applicant.employee",
            cell: ({ getValue }) => <RenderProfile user={getValue()} />,
        },
        {
            id: "title",
            header: "Title",
            accessorKey: "title",
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
        {
            id: "date_scheduled",
            header: "Scheduled",
            accessorKey: "date_scheduled",
            cell: DateTimeCell,
            sortable: true,
        },
        {
            id: "is_cleared",
            header: "Cleared",
            accessorKey: "is_cleared",
            cell: ({ row }) => {
                return row.original?.is_cleared ? "Yes" : "No";
            },
        }
    ];

    const defaultFilters = {
        applicant: { opening: { _eq: openingId } }
    }

    const customSearch = (search) => ({
        _or: [
            { applicant: { employee: { first_name: { _icontains: search } } } },
            { applicant: { employee: { last_name: { _icontains: search } } } },
        ]
    });

    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionGate rule={"create:*"} collection="opening_interviews">
                    <CreateItemButton href={`/apps/openings/${openingId}/interviews/+`}>Interview</CreateItemButton>
                </PermissionGate>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Opening Interviews"
                    endPoint="opening_interviews"
                    storageKey={`openings-list-${openingId}`}
                    perPage={10}
                    columns={columns}
                    filters={defaultFilters}
                    meta={{
                        fields,
                        customSearch,
                    }}
                    href={(item) => `/apps/openings/${openingId}/interviews/${item.id}`}
                    renderFilters={OpeningInterviewsFilters}
                />
            </div>
        </div>
    );
}
